import { useUpdateCompanyStatus } from "@/api/console/companies/useUpdateCompanyStatus";
import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { RadioGroup, RadioGroupItem } from "@/components/ui/radio-group";
import { STATUS } from "@/config/progress";
import useStatuses from "@/hooks/useStatuses";
import { handleCompanyName } from "@/lib/handleName";
import toast from "@/lib/toast";
import useSelectedCompany from "@/src/console/(auth)/companies/_hooks/useCompanyDialog";
import { SpinnerIosRegular } from "@fluentui/react-icons";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { mutate } from "swr";

function UpdateCompanyStatusDialog() {
  const { t } = useTranslation();
  const { statuses } = useStatuses();
  const { type, company, resetDialog } = useSelectedCompany();
  const companyId = company?.id ?? -1;
  const companyName = handleCompanyName(companyId, company?.company_name ?? "");
  const statusId = company?.status.id ?? 1;
  const statusName = company?.status.name ?? "";
  const { trigger: updateStatus, isMutating } = useUpdateCompanyStatus(
    companyId,
    {
      onSuccess: (data) => {
        toast.success(data.message);
        mutate(`/console/companies`);
        resetDialog();
      },
    },
  );
  const [selectedStatus, setSelectedStatus] = useState<string>("1");

  const filteredStatuses = statuses.filter((status) => {
    if (!company) return false;
    const excludeAssessmentEvaluation =
      !company.has_improvement_proposal &&
      status.id === STATUS.ASSESSMENT_EVALUATION_COMPLETED;
    const isPreviousStatus = status.id < statusId;
    return isPreviousStatus && !excludeAssessmentEvaluation;
  });

  return (
    <Dialog
      open={type === "update-status"}
      onOpenChange={(open) => !open && resetDialog()}
    >
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{t("update-status")}</DialogTitle>
        </DialogHeader>
        <div className=" flex flex-col p-6">
          <div>
            <div className=" text-lg font-bold">{companyName}</div>
            <div>現在のステータス : {statusName}</div>
          </div>
          <RadioGroup
            className=" mt-5"
            onValueChange={setSelectedStatus}
            value={selectedStatus}
          >
            {filteredStatuses.map((status) => (
              <div
                key={status.id}
                className=" flex flex-row items-center space-x-2 cursor-pointer"
              >
                <RadioGroupItem
                  id={`status-${status.id}`}
                  value={status.id.toString()}
                />
                <label htmlFor={`status-${status.id}`}>{status.name}</label>
              </div>
            ))}
          </RadioGroup>
          <div className=" flex flex-row w-full justify-end mt-6 space-x-3">
            <Button onClick={() => resetDialog()} variant={"outline"}>
              {t("cancel")}
            </Button>
            <Button
              onClick={() =>
                updateStatus({
                  status: parseInt(selectedStatus),
                })
              }
              LoadingComponent={<SpinnerIosRegular className="animate-spin" />}
              isLoading={isMutating}
            >
              {t("update")}
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}

export default UpdateCompanyStatusDialog;
